import { createSlice, PayloadAction, UnknownAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export type AuthState = {
  msName: string;
  msUsername: string;
  msUserRoles: string[];
  accessToken: string;
  idToken: string;
  expiresOn: number; // Unix timestamp for token expiration
};

const initialAuthState: AuthState = {
  msName: "",
  msUsername: "",
  msUserRoles: [],
  accessToken: "",
  idToken: "",
  expiresOn: 0,
};

const storedState = localStorage.getItem("authState");
const initialState = storedState ? { auth: JSON.parse(storedState) as AuthState } : { auth: initialAuthState };

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    ADD_AUTH_USER: (state, action: PayloadAction<{ auth: AuthState }>) => {
      state.auth = action.payload.auth;
    },
    REMOVE_AUTH_USER: (state) => {
      state.auth = initialAuthState;
    },
  },
});

export const { ADD_AUTH_USER, REMOVE_AUTH_USER } = authSlice.actions;

export const selectAuth = (state: RootState) => state.auth;

// Middleware to sync state with localStorage
const syncAuthStateWithLocalStorage =
  (reducer: {
    (state: { auth: AuthState } | undefined, action: UnknownAction): { auth: AuthState };
    (arg0: any, arg1: any): any;
  }) =>
  (state: any, action: any) => {
    const newState = reducer(state, action);
    localStorage.setItem("authState", JSON.stringify(newState.auth));
    return newState;
  };

export default syncAuthStateWithLocalStorage(authSlice.reducer);
